























import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import { Curso } from '@/__env/lib/Cursos';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { Respuesta } from '@/__env/lib/Cursos/Respuestas';
import { OpcionElegida } from '@/__env/lib/Cursos/Respuestas/Respuesta.lib';
import { Opcion } from '@/__env/lib/Cursos/Preguntas/Opciones';
@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }
    public get Resultado(): Resultado { return Model.Resultado; }

    @Prop()
    public Opcion: Opcion;

    @Prop()
    public Respuesta: Respuesta;

    public get Elegida(): OpcionElegida
    {
        return this.Respuesta.OpcionesElegidas.find( x => x.Opcion == this.Opcion.Id );
    }

}
